/**
 * 过滤方式去重
 * @param {array} array
 * @returns {array}
 */
export default function arrayUnique(array) {
    var res = [];
    for (var i = 0, arrayLen = array.length; i < arrayLen; i++) {
        for (var j = 0, resLen = res.length; j < resLen; j++) {
            if (array[i] === res[j]) {
                break;
            }
        }
        if (j === resLen) {
            res.push(array[i]);
        }
    }
    return res;
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/utils/arrayUnique.js
// module id = null
// module chunks = 